import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import {
  FaCheckCircle,
  FaClock,
  FaSmile,
  FaHeadset,
  FaBoxes,
  FaFileAlt,
  FaIdBadge,
  FaClipboardCheck,
  FaMapMarkedAlt,
  FaBusAlt,
  FaIndustry,
  FaCity,
  FaShieldAlt,
  FaBolt,
  FaTrain,
  FaFlask,
  FaPlane,
  FaBuilding,
  FaCode,
  FaMobileAlt,
  FaPaintBrush,
  FaBullhorn,
  FaSearch,
  FaCloud,
  FaGlobe,
  FaRocket,
  FaCube,
  FaAnchor,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import homeimg from "../../image/hero-img8.png";
import Service from "./Service";
import stocklogo from ".././../image/project/stocklogo.png";
import passlogo from ".././../image/project/passlogo.png";
import doclogo from ".././../image/project/doclogo.png";
import qmslogo from ".././../image/project/qmslogo.png";
import tracklogo from ".././../image/project/tracklogo.png";
import shuttlelogo from ".././../image/project/shuttlelogo.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
const ourSolutions = [
  {
    title: "Intelistock",
    description:
      "AI-Based Inventory Management with real-time traceability, alerts & forecasting.",
    icon: stocklogo,
    path: "solution/intelistock",
  },
  {
    title: "inteliDoc",
    description:
      "Secure Online Drawing Management System for technical drawings and engineering documentation.",
    icon: doclogo,
    path: "solution/intelidoc",
  },
  {
    title: "InteliPass",
    description:
      "Smart Visitor & Employee Pass with facial recognition, QR validation & gate integration.",
    icon: passlogo,
    path: "solution/intelipass",
  },
  {
    title: "InteliQMS",
    description:
      "Digital Quality Management System for aviation/defense QA compliance workflows.",
    icon: qmslogo,
    path: "solution/inteliqms",
  },
  {
    title: "InteliTrack",
    description:
      "Real-time logistics and asset tracking platform with RFID, LoRa & GPS integration.",
    icon: tracklogo,
    path: "solution/intelitrack",
  },
  {
    title: "InteliShuttle",
    description:
      "AI & GPS-powered bus tracking and access control system for industrial campuses.",
    icon: shuttlelogo,
    path: "solution/intelishuttle",
  },
];

const industries = [
  {
    title: "Steel Plants",
    icon: <FaIndustry />,
    description: "Solutions for large-scale steel manufacturing plants.",
  },
  {
    title: "Defense",
    icon: <FaShieldAlt />,
    description: "Mission-critical applications for defense research units.",
  },
  {
    title: "Industrial Manufacturing",
    icon: <FaBuilding />,
    description: "Smart factory automation and quality control systems.",
  },
  {
    title: "Power & Energy",
    icon: <FaBolt />,
    description: "Power grid and utility management systems.",
  },
  {
    title: "Smart Cities",
    icon: <FaCity />,
    description: "Integrated solutions for smart city infrastructure.",
  },
  {
    title: "Public Sector Units",
    icon: <FaFlask />,
    description: "Custom ERP and asset tracking for government sectors.",
  },
  {
    title: "Aerospace",
    icon: <FaPlane />,
    description: "Quality assurance and compliance tracking in aerospace.",
  },
  {
    title: "Railways & Transport",
    icon: <FaTrain />,
    description: "Fleet tracking and passenger access solutions.",
  },
];
const clientLogos = [
  { name: "Aditya Birla", logo: `${process.env.PUBLIC_URL}/img/client/Aditya_Birla.png` },
  { name: "DRDO", logo: `${process.env.PUBLIC_URL}/img/client/DRDO_Logo.png` },
  { name: "HAL", logo: `${process.env.PUBLIC_URL}/img/client/HAL_Logo.jpg` },
  { name: "JSPL", logo: `${process.env.PUBLIC_URL}/img/client/JSPL_Logo.png` },
  { name: "JSW", logo: `${process.env.PUBLIC_URL}/img/client/JSW_Logo.png` },
  { name: "NTPC", logo: `${process.env.PUBLIC_URL}/img/client/NTPC_Logo.png` },
  { name: "SAIL", logo: `${process.env.PUBLIC_URL}/img/client/SAIL_Logo.png` },
  { name: "Timken", logo: `${process.env.PUBLIC_URL}/img/client/Timken_Logo.png` },
];

const Home = () => {
  return (
    <div className="bg-white text-dark">
      {/* Hero Section */}
      <section className="hero-section" id="home">
        <Container className="py-2">
          <Row className="align-items-center">
            <Col md={6} className="mb-4 mb-md-0" data-aos="fade-right">
              <h1 className="fw-bold text-orange mb-3">
                Empowering Digital Transformation in Industry & Defense
              </h1>
              <p className=" text-muted">
                From AI-powered inventory systems to drawing management, we
                deliver secure, scalable, and smart solutions for India's most
                mission-critical sectors.
              </p>
              <div className="d-flex flex-wrap gap-2">
                <Link
                  to="/about"
                  variant="outline-primary"
                  className="btn btn-outline-primary px-4 py-2"
                >
                  Explore Services
                </Link>
              </div>
            </Col>

            <Col
              md={6}
              className="d-none d-md-block text-center"
              data-aos="fade-left"
            >
              <img src={homeimg} alt="Hero" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </section>

      <Service />

      {/* Testimonials Section */}
      <section className="section" id="projects">
        <Container>
          <h2
            className="text-center fw-bold mb-4"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            Our Solutions
          </h2>

          <div className="row g-4">
            {ourSolutions.map((item, idx) => (
              <Col
                md={6}
                lg={4}
                key={idx}
                data-aos="fade-up"
                data-aos-delay={idx * 200} // Staggered animation
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                <div className="card solution-card shadow-sm h-100 d-flex flex-column justify-content-between">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="icon-box shadow-sm rounded-2">
                        <img src={item.icon} height="35px" width="35px"></img>
                      </div>
                      <h5 className="mb-0">{item.title}</h5>
                    </div>
                    <p>{item.description}</p>
                  </div>
                  <div className="mt-2 text-end">
                    <Link
                      to={item.path}
                      className="btn btn-sm btn-light rounded-pill px-3"
                    >
                      Learn More
                    </Link>
                  </div>
                </div>
              </Col>
            ))}
          </div>
        </Container>
      </section>

      <section className="section">
        <div className="container">
          <h2
            className="text-center fw-bold mb-1"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            Industries We Serve
          </h2>

          <Row className="gy-4 mt-1">
            {industries.map((item, index) => (
              <Col
                key={index}
                xs={12}
                sm={6}
                md={4}
                lg={3}
                data-aos="fade-up" // 👈 same animation for all
                data-aos-delay={index * 200} // 👈 one-by-one effect
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                <Card className="industry-card h-100 text-center shadow-sm">
                  <Card.Body>
                    <div className="industry-icon mb-3">{item.icon}</div>
                    <Card.Title>{item.title}</Card.Title>
                    <Card.Text className="small text-muted">
                      {item.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="bg-white section" id="our-clients">
        <div className="container">
          <h2
            className="text-center fw-bold mb-1"
            data-aos="fade-up"
            data-aos-duration="100"
          >
            Our Clients
          </h2>
          <Swiper
            modules={[Autoplay]}
            loop={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            breakpoints={{
              0: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
            spaceBetween={20}
          >
            {clientLogos.map((client, idx) => (
              <SwiperSlide key={idx}>
                <div
                  data-aos="fade-up"
                  data-aos-delay={idx * 150}
                  data-aos-duration="800"
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    height: "120px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    style={{
                      maxHeight: "60px",
                      width: "auto",
                      objectFit: "contain",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      <section className="section contact-cta-section text-center">
        <div className="container">
          <h2 className="fw-bold" data-aos="fade-up" data-aos-duration="800">
            Ready to Transform Your Business?
          </h2>
          <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="800">
            Let’s discuss your ideas, projects, and challenges. We’re here to
            build your vision and deliver excellence.
          </p>
          <Link
            to="/contact"
            className="btn btn-lg contact-cta-btn"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="800"
          >
            Contact Us
          </Link>
        </div>
      </section>

      {/* <section className="py-5 bg-light">
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h5
                className="fw-bold"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                International Clients
              </h5>
              <p
                className="text-muted small"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Trusted by brands across 10+ countries
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mt-3">
                {clientLogos.map((client, i) => (
                  <div
                    key={i}
                    className="logo-badge-wrapper"
                    data-aos="zoom-in"
                    data-aos-delay={i * 100}
                    data-aos-duration="800"
                  >
                    <div className="logo-badge text-center">{client.icon}</div>
                    <span className="logo-tooltip">{client.name}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          <Row className="text-center">
            <Col
              data-aos="fade-up"
              data-aos-delay="600"
              data-aos-duration="1000"
            >
              <h5 className="fw-bold">24/7 Customer Support</h5>
              <p className="text-muted">
                We’re available round the clock for your needs.
              </p>
              <FaHeadset className="fs-1 text-orange" />
            </Col>
          </Row>
        </Container>
      </section> */}
    </div>
  );
};

export default Home;
